import { monthIndexMap } from './constants';
import { countryMapList } from '../data/countryMapList';
import { calculateCountDown } from './dateHelper';

export const getLastFiveMonthList = () => {
  const monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const today = new Date();
  let d;

  const fiveMonthList = [];

  for (let i = 5; i > 0; i -= 1) {
    d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    const month = monthList[d.getMonth()];
    const monthName = monthNames[d.getMonth()];
    const year = d.getFullYear();
    fiveMonthList.push({
      month,
      year,
      monthName,
    });
  }

  return fiveMonthList;
};

export const formatStackedGraphData = (
  data,
  paramNames,
  paramColors,
  chartLabels
) => {
  const graphData = [];
  Object.keys(data).forEach((key) => {
    if (data[key]) {
      graphData.push({
        label: paramNames[key],
        data: data[key],
        backgroundColor: paramColors[key],
      });
    }
  });
  return {
    labels: chartLabels,
    datasets: graphData,
  };
};

export const formatRevenueDataGraph = (rawData, factor = 1) => {
  return rawData.map((data) => {
    const { value, label } = data;
    return {
      x: label,
      y: value / factor,
    };
  });
};

export const formatLastMonthRevenueData = (rawData, window = 'month') => {
  const {
    currentRevenue,
    percentGrowthRevenue,
    forecastRevenue,
    daysInWindow,
  } = rawData;
  const toDateRevenue = {
    headlineStat: {
      num: currentRevenue / 100,
      unit: '$',
      label: '',
    },
    change: parseFloat(percentGrowthRevenue).toFixed(0),
    label: `from ${window === 'month' ? ' last month' : ' previous'}`,
    stats: [
      {
        label: 'Daily Average',
        num: currentRevenue / 100 / daysInWindow,
        unit: '$',
      },
      {
        label: 'Forecast',
        num: forecastRevenue / 100,
        unit: '$',
      },
    ],
  };
  return toDateRevenue;
};

export const formatLastMonthSignupData = (signUpData, courseWiseSignUp) => {
  const { currentMonthSignUps, percentGrowthSignUps } = signUpData;
  const toDateSignups = {
    headlineStat: {
      num: currentMonthSignUps,
      unit: '',
      label: 'Sign-ups',
    },
    change: parseFloat(percentGrowthSignUps).toFixed(0),
    label: 'from last month',
    stats: formatDataByCourse(courseWiseSignUp.slice(0, 2), ''),
  };
  return toDateSignups;
};

export const formatLastMonthAlumniData = (alumniData, courseWiseAlumni) => {
  const { currentAlumniCount, percentGrowthAlumni } = alumniData;
  const monthToDateAlumni = {
    headlineStat: {
      num: currentAlumniCount,
      unit: '',
      label: 'Students',
    },
    change: parseFloat(percentGrowthAlumni).toFixed(0),
    label: 'from last month',
    stats: formatDataByCourse(courseWiseAlumni.slice(0, 2), ''),
  };
  return monthToDateAlumni;
};

export const formatRatingData = (ratings) => {
  const { totalRatingsCount, ratingGrowth, currentRating } = ratings;
  const formattedRating = {
    headlineStat: {
      num: currentRating,
      unit: '',
      label: 'Average Ratings',
    },
    change: ratingGrowth,
    label: 'from last month',
    studentStat: {
      num: totalRatingsCount,
      label: 'Students Rated',
    },
    averageRating: currentRating,
  };
  return formattedRating;
};

export const formatDataByCourse = (dataList, unit, factor = 1) =>
  dataList.map((data) => {
    const { courseName, value } = data;
    return {
      label: courseName,
      num: value / factor,
      unit: unit,
    };
  });

export const formatCountryData = (dataList) => {
  const top5CountryIndices = [...Array(5).keys()];
  const otherCountries = dataList.slice(5, dataList.length);
  const otherCountriesSum = otherCountries.reduce(
    (a, value) => a + value.value,
    0
  );
  const countryData = [];
  top5CountryIndices.forEach((index) => {
    if (countryMapList?.[dataList?.[index]?.country]) {
      countryData.push({
        name: countryMapList?.[dataList?.[index]?.country]?.name,
        value: dataList?.[index].value,
      });
    }
  });

  countryData.push({
    name: 'Others',
    value: otherCountriesSum,
  });

  return countryData;
};

export const formatDateFromNow = (startDate) => {
  const now = new Date().toISOString();
  const countdown = calculateCountDown(startDate, now);
  const { secs, mins, hrs, days, years } = countdown;
  if (years > 0) {
    return new Date(startDate).toLocaleDateString();
  } else if (days > 0) {
    if (days > 31) {
      return new Date(startDate).toLocaleDateString();
    } else {
      return `${days} days ago`;
    }
  } else if (hrs > 0) {
    return `${hrs} hours ago`;
  } else if (mins > 0) {
    return `${mins} minutes ago`;
  } else if (secs > 0) {
    return `${secs} secs ago`;
  }
};
